import React, { useState, useEffect } from 'react';
import { Menu, Container } from 'semantic-ui-react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

function Navigation() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };
  
  return (
    <Menu 
      fixed='top' 
      inverted
      borderless
      className={`navigation-menu ${isScrolled ? 'scrolled' : ''}`}
    >
      <Container className="navigation-container">
        <Menu.Item as={Link} to="/" active={location.pathname === '/'} header className="navigation-item">
          {t('nav.wedding')}
        </Menu.Item>
        <Menu.Item as={Link} to="/nosotros" active={location.pathname === '/nosotros'} className="navigation-item">
          {t('nav.aboutUs')}
        </Menu.Item>
        
        <div className="navigation-logo">
          A&D
        </div>
        
        <Menu.Menu position='right'>
          {location.pathname !== '/rsvp' && (
            <Menu.Item
              as={Link}
              to="/rsvp"
              className="navigation-rsvp-button"
            >
              <span className="rsvp-label-full">{t('nav.rsvp')}</span>
              <span className="rsvp-label-short">Confirmar</span>
            </Menu.Item>
          )}
          <Menu.Item className="navigation-language">
            <div className="navigation-lang-toggle">
              <button
                className={`lang-btn ${i18n.language === 'es' ? 'active' : ''}`}
                onClick={() => handleLanguageChange('es')}
              >
                ES
              </button>
              <button
                className={`lang-btn ${i18n.language === 'ro' ? 'active' : ''}`}
                onClick={() => handleLanguageChange('ro')}
              >
                RO
              </button>
            </div>
          </Menu.Item>
        </Menu.Menu>
      </Container>
    </Menu>
  );
}

export default Navigation;
